import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HelperService } from '@app/services/helper.service';
import { FixMeLater } from 'angularx-qrcode';

const QrCodeName: string = 'CT:SPLR:ID';
const elementType: string = 'canvas';

@Component({
    selector: 'app-view-qr-code',
    templateUrl: './view-qr-code.component.html',
    styleUrl: './view-qr-code.component.scss',
    standalone: false
})
export class ViewQrCodeComponent implements OnInit {
  @ViewChild("qrCode") qrCode!: FixMeLater;
  
  downloading = false;
  qrCodeStr!: string;
  logoFile: any;

  constructor(
    public dialogRef: MatDialogRef<ViewQrCodeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private helper: HelperService
  ) { }

  ngOnInit(): void {
    this.qrCodeStr = JSON.stringify(this.data.qrCodeString);
  }

  onDownloadQRCode() {
    let qrCodeElement: any = null
    let filename = `supplier_${this.data.name}_#${this.data.id}-_qrcode.png`;
    this.downloading = true;

    if (elementType === "canvas") {
      // fetches base 64 data from canvas
      qrCodeElement = this.qrCode.qrcElement.nativeElement
        .querySelector("canvas")
        .toDataURL("image/png")
    } else if (elementType === "img" || elementType === "url") {
      // fetches base 64 data from image
      // qrCodeElement contains the base64 encoded image src
      // you might use to store somewhere
      qrCodeElement = this.qrCode.qrcElement.nativeElement.querySelector("img").src
    } else {
      alert("Set elementType to 'canvas', 'img' or 'url'.")
    }

    setTimeout(() => {
      if (qrCodeElement) {
        // converts base 64 encoded image to blobData
        let blobData = this.helper.convertBase64ToBlob(qrCodeElement)
        // saves as image
        const blob = new Blob([blobData], { type: "image/png" })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = url
        // name of the file
        link.download = filename
        link.click();
        this.downloading = false;
      }
    }, 20);
  }

  onClose(){
    this.dialogRef.close();
  }
}
